<template>
    <div>
        <ul type="card" class="cust-tabs">
            <li :class="{active:activeName == 'GeneralSettings'}">
                <a href="javascript:void(0)" @click="handleClick('GeneralSettings')">{{ $t('General Settings') }}</a>
            </li>
            <li :class="{active:activeName == 'Menu'}">
                <a href="javascript:void(0)" @click="handleClick('Menu')">{{ $t('Menu') }}</a>
            </li>
            <li :class="{active:activeName == 'Role'}">
                <a href="javascript:void(0)" @click="handleClick('Role')">{{ $t('Role') }}</a>
            </li>
             <li :class="{active:activeName == 'Admins'}">
                <a href="javascript:void(0)" @click="handleClick('Admins')">{{ $t('Admins') }}</a>
            </li>
            <li :class="{active:activeName == 'ActivityLogs'}">
                <a href="javascript:void(0)" @click="handleClick('ActivityLogs')">{{ $t('Activity Logs') }}</a>
            </li>
            <li :class="{active:activeName == 'EmailTemplates'}">
                <a href="javascript:void(0)" @click="handleClick('EmailTemplates')">{{ $t('Email Templates') }}</a>
            </li>
            <!-- <li :class="{active:['AccountClasses','AccountGroups','Accounts','AccountSettings'].includes(activeName)}">
                <el-dropdown trigger="click" :append-to-body="false" @command="handleRoutes">
                    <span class="el-dropdown-link">
                        <a href="javascript:void(0)">{{$t('General Account Settings')}}<i class="el-icon-arrow-down el-icon--right"></i></a>
                    </span>
                    <el-dropdown-menu slot="dropdown" :append-to-body="false">
                        <el-dropdown-item :disabled="$route.name == 'AccountSettings'" :command="{name:'AccountSettings'}"><a href="javascript:void(0)">{{ $t('Account Settings') }}</a></el-dropdown-item>
                        <el-dropdown-item :disabled="$route.name == 'AccountClasses'" :command="{name:'AccountClasses'}"><a href="javascript:void(0)">{{ $t('Account Classes') }}</a></el-dropdown-item>
                        <el-dropdown-item :disabled="$route.name == 'AccountGroups'" :command="{name:'AccountGroups'}"><a href="javascript:void(0)">{{ $t('Account Groups') }}</a></el-dropdown-item>
                        <el-dropdown-item :disabled="$route.name == 'Accounts'" :command="{name:'Accounts'}"><a href="javascript:void(0)">{{ $t('Accounts') }}</a></el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </li> -->
        </ul>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        created() {
            this.activateTab(this.activeName, this.$route.path);
        },
        data() {
            return {
                activeName: this.$route.name ? this.$route.name : 'GeneralSettings'
            };
        },
        methods: {
            handleClick(tab, event) {
                this.activateTab(tab);
            },
            handleRoutes(routeObj) {
                this.$router.push(routeObj);
            },
            activateTab(tabName, currentRoutePath = '') {
                if (tabName == "GeneralSettings") {
                    this.$router.push({
                        name: "GeneralSettings",
                    });
                    this.activeName = "GeneralSettings";
                } else if (tabName == "Menu" || currentRoutePath.includes('menu')) {
                    if (currentRoutePath != '') {
                        this.$router.push({
                            path: currentRoutePath,
                        });
                    } else {
                        this.$router.push({
                            name: "Menu",
                        });
                    }
                    this.activeName = "Menu";
                } else if (tabName == "Role" || currentRoutePath.includes('roles')) {
                    if (currentRoutePath != '') {
                        this.$router.push({
                            path: currentRoutePath,
                        });
                    } else {
                        this.$router.push({
                            name: "Role",
                        });
                    }
                    this.activeName = "Role";
                } else if (tabName == "Permissions") {
                    this.$router.push({
                        name: "Permissions",
                    });
                    this.activeName = "Permissions";
                } else if (tabName == "ActivityLogs") {
                    this.$router.push({
                        name: "ActivityLogs",
                    });
                    this.activeName = "ActivityLogs";
                } else if (tabName == "EmailTemplates" || currentRoutePath.includes('email-templates')) {
                    if (currentRoutePath != '') {
                        this.$router.push({
                            path: currentRoutePath,
                        });
                    } else {
                        this.$router.push({
                            name: "EmailTemplates",
                        });
                    }
                    this.activeName = "EmailTemplates";
                
                } else if (tabName == "Admins" || currentRoutePath.includes('admins')) {
                    if (currentRoutePath != '') {
                        this.$router.push({
                            path: currentRoutePath,
                        });
                    } else {
                        this.$router.push({
                            name: "Admins",
                        });
                    }
                    this.activeName = "Admins";
                } else if (tabName == "AccountGroups") {
                    this.$router.push({
                        name: "AccountGroups",
                    });
                    this.activeName = "AccountGroups";
                } else if (tabName == "AccountClasses") {
                    this.$router.push({
                        name: "AccountClasses",
                    });
                    this.activeName = "AccountClasses";
                } else if (tabName == "Accounts") {
                    this.$router.push({
                        name: "Accounts",
                    });
                    this.activeName = "Accounts";
                }
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Layout/Settings.vue